module.exports = __webpack_public_path__ + "static/media/canLeadToStroke.c6f99db7.mp3";